import { useRef, useState } from "react";
import ProductTypeSelector from "../ProductTypeSelector";
import { GridSearch } from "./GridParts";

// What the Products, Bundles and Packages scrollers share (each used to carry
// its own copy): the List / Grid switch, the slot for the grid's search box,
// and the layout around the list or the grid.

// view / setView live in Products.jsx (all tabs share them). handleView(target)
// is the List / Grid buttons' handler: each shows its own view, and pressing
// the one already showing does nothing (until 2026-10-19 both toggled, so it
// switched away: KNOWN_ISSUES.md SP-055). Leaving Grid drops the grid's search
// box, as before. refocusView lets the switches, which move between the list's
// toolbar and the grid's row, keep focus on the pressed button.
export function useLibraryView(view, setView) {
  const [filter, setFilter] = useState(null);
  const refocusView = useRef(null);
  const handleView = (target) => {
    if (target === view) return;
    if (view === "Grid") setFilter(null);
    setView(target);
  };
  return { filter, setFilter, handleView, refocusView };
}

// The actions are `lead` (the location line, or Add Bundle / Add Package)
// then the tab and view switches. In List view they go to the list's toolbar:
// list(actions) passes them on as BoltTable's headerButtons. In Grid view they
// sit next to the grid's search box, and the row and the grid fill the list
// view's 500px box. barClass is the row's old class (Products.css styles it).
export function LibraryFrame({ view, library, StepCheck, SetStepCheck, lead, barClass, grid, list }) {
  const actions = (
    <div className="myprod__actions">
      {lead}
      <ProductTypeSelector
        StepCheck={StepCheck}
        SetStepCheck={SetStepCheck}
        view={view}
        handleView={library.handleView}
        refocusView={library.refocusView}
      />
    </div>
  );

  return (
    <>
      <div className={`myprod__frame${view === "Grid" ? " is-grid" : ""}`}>
        {/* The grid's search box and the actions; empty, and hidden, in List
            view, where the actions are in the table's toolbar. While the grid
            has no search box (nothing to search yet), an invisible one keeps
            its place: the grid's page size is measured from the space left
            under this row, so the row must not change height when the box
            comes and goes (it re-measured and asked again, or kept asking
            on an empty tab). */}
        <div className={`${barClass} myprod__bar`}>
          {library.filter ?? (view === "Grid" && <GridSearch hidden />)}
          {view === "Grid" && actions}
        </div>
        {view === "Grid" && grid}
      </div>
      {view === "List" && (
        <div className="ship__page_myproduct_listing_bolt_table">{list(actions)}</div>
      )}
    </>
  );
}
